/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Private_Models_Connection_Too_ManyInputs */



/**
* | output |
* | --- |
* | "At most {max} models per import. Add the others in a second import." |
*
* @param {Private_Models_Connection_Too_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_too_many = /** @type {((inputs: Private_Models_Connection_Too_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Too_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Höchstens ${i?.max} Modelle pro Import. Fügen Sie die übrigen in einem zweiten Import hinzu.`)
	return /** @type {LocalizedString} */ (`At most ${i?.max} models per import. Add the others in a second import.`)
});